<tile [hideBackgroundImage]="true" [link]="['/cv/', cv.Id]">
  <div
    class="container cv-list-element-progress-{{ cv.Progress }} flex flex-col flex-between-stretch"
    id="cv-id-{{ cv.Id }}"
  >
    <div class="body">
      <div class="body-header flex flex-between-center max-md:hidden">
        <div class="labels">
          @if (cv.IsSent) {
            <span class="pill" color="success">Sent to Darize</span>
          }
          @if (!cv.IsSent) {
            <span class="pill" color="alternative">Draft</span>
          }
          <span class="language pill">{{ cvLanguage.LanguageName }}</span>
        </div>
      </div>
      <h3 class="cv-name">
        <a [routerLink]="['/cv/', cv.Id]" (click)="stopPropagation($event)">
          {{ cv.Name }}
        </a>
      </h3>
      <p class="title max-md:hidden">
        {{ cv.Title || 'No job title' }}
      </p>
    </div>

    <div class="footer">
      <progress-bar [progress]="cv.Progress" #progressBar label="CV strength">
        <div class="main-info flex max-md:flex-row-reverse flex-full">
          <h5 class="progress-header font-bold">
            {{ progressBar.label }}:
            <span [value]="progressBar.progress" numberScroll>{{ progressBar.progress }}</span>
            %
          </h5>
          <div class="additional-info-title flex-[1_0_auto] md:hidden">
            {{ cv.Title }}
          </div>
        </div>
        @if (cv.MissedCvSectionsCount > 0) {
          <div class="missing-sections max-md:hidden">
            You're missing {{ cv.MissedCvSectionsCount }}
            <span [ngPlural]="cv.MissedCvSectionsCount">
              <ng-template ngPluralCase="=1">section</ng-template>
              <ng-template ngPluralCase="other">sections</ng-template>
            </span>
            to own the perfect CV.
          </div>
        }
      </progress-bar>
      <div class="created max-md:hidden">
        <mat-icon svgIcon="calendar_big"></mat-icon>
        <span class="created-text">Last modified {{ cv.LastModifiedDate | defaultDate: 'day' : true : false }}</span>
      </div>
    </div>
  </div>
</tile>
